/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
import "emoji-mart/css/emoji-mart.css";
import "react-markdown-editor-lite/lib/index.css";

import {
  DeleteOutlined,
  FilterFilled,
  InfoCircleOutlined,
  SyncOutlined,
  WindowsFilled,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Input,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";
import { SlackEditorPreview } from "../TextEditor/SlackEditor";

const FUNCTION_MAP = {
  postToChannel: "Channel Post",
  sendDMs: "Direct Message",
  sendSurveyQuestions: "Survey",
  sendDMsOnboarding: "Onboarding DM",
};

const PreviewMessageModal = (props) => {
  const supabase = getSupaClient();
  let preview = <div> In preview modal</div>;
  const { scheduledTime, scheduledTimezone, createdByName, id } = props.task;

  const [loading, setLoading] = useState(true);
  const [payload, setPayload] = useState({});
  const { tagdata } = props;

  const firstQuestion =
    payload.onboarding_questions && payload.onboarding_questions[0];

  let welcomeMessage;
  let onboardingQuestions;

  if (firstQuestion?.message) {
    welcomeMessage = firstQuestion.message;
    onboardingQuestions = payload.onboarding_questions.slice(1);
  } else {
    onboardingQuestions = payload.onboarding_questions;
  }

  /**
   * Load the payload data for a given scheduled_task
   */
  const loadPayload = async () => {
    const { data, error } = await supabase
      .from("scheduled_tasks")
      .select("payload")
      .eq("id", id);
    if (data) {
      setPayload(data[0].payload);
    }
    if (error) {
      window.analytics("Error loading payload");
    }
    setLoading(false);
  };

  useEffect(() => {
    loadPayload();
  }, [props.task]);

  if (props.task.run_function === "sendSurveyQuestions") {
    const columns = [
      {
        title: `Name`,
        dataIndex: "name",
        key: "name",
        width: "25%",
      },
    ];
    preview = (
      <>
        <div style={{ margin: 5 }}>
          Sending the following Survey on <b>{scheduledTime}</b> (
          {scheduledTimezone}) as <b>{createdByName}</b>
        </div>
        {welcomeMessage && (
          <div>
            <p>
              Welcome message:{" "}
              <span className="flex font-bold">{welcomeMessage}</span>
            </p>
          </div>
        )}
        <div>
          {onboardingQuestions &&
            onboardingQuestions.map((item, index) => (
              <>
                <div>
                  <span>
                    Question {index + 1} :
                    <Input value={item.question} type="text" />
                  </span>
                </div>
                <div>
                  {item.answers &&
                    item.answers.map((option, optionIndex) => (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            margin: 5,
                          }}
                        >
                          <div>
                            <Input value={option.display} type="text" />
                          </div>
                          <div>
                            {option.maps_to_tags &&
                              option.maps_to_tags.map((item) => {
                                return tagdata.map((tagItem) =>
                                  tagItem.id === item ? (
                                    <Tag
                                      color={tagItem.color}
                                      style={{ margin: 0 }}
                                      key={tagItem.id}
                                    >
                                      {tagItem.name}
                                    </Tag>
                                  ) : null
                                );
                              })}
                          </div>
                        </div>
                      </>
                    ))}
                </div>
              </>
            ))}
        </div>
        <div style={{ marginTop: 20 }}>
          <p>
            Survey sent to <b>{payload.recipient?.length} users </b>
          </p>
          <Table
            pagination={false}
            dataSource={payload.recipient}
            columns={columns}
          />
        </div>
      </>
    );
  }
  // if scheduled post in channel
  if (props.task.run_function === "postToChannel") {
    const { channel } = payload;
    preview = (
      <div>
        Sending the following message <b>#{channel?.name}</b> on{" "}
        <b>{scheduledTime}</b> ({scheduledTimezone}) as <b>{createdByName}</b>
        {payload.message ? (
          <SlackEditorPreview message={payload.message} />
        ) : (
          <div>
            <textarea
              style={{
                width: "100%",
                height: "250px",
                padding: 4,
                borderRadius: 5,
                overflowWrap: "anywhere",
                border: "solid 1px",
                marginTop: 4,
              }}
              value={JSON.stringify(payload.block_kit)}
              readOnly
            />
          </div>
        )}
      </div>
    );
  }
  if (
    props.task.run_function === "sendDMs" ||
    props.task.run_function === "sendDMsOnboarding"
  ) {
    const previewMessagesColumns = [
      {
        title: "User",
        dataIndex: "user",
        key: "user",
        width: "25%",
      },
      {
        title: "Message",
        dataIndex: "message",
        key: "message",
        width: "75%",
        render: (text, record) => <SlackEditorPreview message={record} />,
      },
    ];
    preview = (
      <div>
        Sending the following messages on <b>{scheduledTime}</b> (
        {scheduledTimezone}) as <b>{createdByName}</b>
        <Table
          dataSource={payload.messages}
          columns={previewMessagesColumns}
          style={{}}
        />
      </div>
    );
  }

  return <Spin spinning={loading}>{preview}</Spin>;
};

const ScheduledMessagesTable = (props) => {
  // eslint-disable-next-line no-unused-vars
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [scheduledTasks, setScheduledTasks] = useState([]);
  const [isPreviewVisible, setPreviewVisible] = useState(false);
  const [previewMessage, setPreviewMessage] = useState({});
  const [tableState, setTableState] = useState({
    filteredInfo: {
      type: [
        "sendSurveyQuestions",
        "sendDMs",
        "postToChannel",
        "sendDMsOnboarding",
      ],
    },
  });
  const [allTags, setAllTags] = useState([]);
  const [showFilter, setShowFilter] = useState(false);

  const teamId = localStorage.getItem("team-id");

  const formatInfo = (task) => {
    // format the info value to display, based on the type of task
    // eslint-disable-next-line eqeqeq
    if (task.run_function === "postToChannel") {
      return `in #${task.channelName}`;
    }
    if (task.run_function === "sendDMs") {
      return `to ${task.recipients.length} ${
        task.recipients.length > 1 ? "members" : "member"
      } `;
    }
    if (task.run_function === "sendSurveyQuestions") {
      return `to ${task.recipient.length} ${
        task.recipient.length > 1 ? "members" : "member"
      } `;
    }
    if (task.run_function === "sendDMsOnboarding") {
      if (task.recipients.length > 1) {
        return `${task.recipients.length} members`;
      }
      return `to ${task.firstMessageUser}`;
    }
  };

  const mapResults = async (scheduledTasks) => {
    scheduledTasks = await scheduledTasks.map((task) => {
      task.key = task.id;
      // check if schedule time local isn't there
      if (task.scheduled_time_local) {
        task.scheduledTime = moment(task.scheduled_time_local).format(
          "MMM D h:mm a"
        );
      }
      // if no schedule time, show time based on utc
      else {
        task.scheduledTime = moment(task.scheduled_time_utc)
          .tz(moment.tz.guess())
          .format("MMM D h:mm a");
      }
      // check if no timezone
      if (task.timezone) {
        task.scheduledTimezone = task.timezone;
      } else {
        task.scheduledTimezone = moment.tz.guess();
      }

      task.createdTime = moment(task.created_at).fromNow();
      task.createdByName =
        // eslint-disable-next-line no-nested-ternary
        task.sender ? task.sender.name : "bot";
      task.type = FUNCTION_MAP[task.run_function];
      task.info = formatInfo(task);
      return task;
    });
    return scheduledTasks;
  };

  const loadTeamTags = async () => {
    const { data, error } = await supabase
      .from("tags")
      .select("id, name, color")
      .eq("team", teamId);
    if (data) {
      // console.log("dataaa", data);
      setAllTags(data);
    }
    if (error) {
      window.analytics("Error loading tags");
      // console.log("Error", error);
    }
  };

  useEffect(() => {
    loadTeamTags();
  }, []);

  /**
   * Load all scheduled tasks for this team, paginating 100 results at a time. This is needed
   * because we pull the payload column, which has large amounts of data. For customers that have
   * hundreds of tasks with large payloads, a bulk fetch is very slow and causes the page to hang
   */
  const loadScheduledTasks = async () => {
    setLoading(true);
    const pageSize = 100;
    let from = 0;
    let done = false;
    let allTasks = [];
    /* eslint-disable no-await-in-loop */
    while (!done) {
      const { data, error } = await supabase
        .from("scheduled_tasks")
        .select(
          // only pull necessary payload fields
          // without this, too much data is fetched for large teams
          `
          id,
          scheduled_time_utc,
          users: created_by (slack_id, name),
          sender: sender (slack_id, name),
          run_function,
          channelName:payload->channel->>name,
          payload->recipient,
          payload->recipients,
          firstMessageUser:payload->messages->0->>user,
          scheduled_time_local,
          timezone,
          created_at,
          status
        `
        )
        .filter("team", "eq", teamId)
        .order("scheduled_time_utc", { ascending: false })
        .range(from, from + pageSize);
      if (error) {
        console.log("error in loadScheduledTasks", error);
        break;
      }
      setLoading(false);
      allTasks = allTasks.concat(data);
      const displayResults = await mapResults(allTasks);
      setScheduledTasks(displayResults);
      if (data.length < pageSize) {
        done = true;
      } else {
        from += pageSize;
      }
    }
  };

  const loadPageData = async () => {
    await loadScheduledTasks();
  };

  useEffect(() => {
    loadPageData();
  }, []);

  const deleteScheduledTask = async (taskId) => {
    const { data, error } = await supabase
      .from("scheduled_tasks")
      .delete()
      .match({ id: taskId });
    if (error) {
      window.analytics("Error deleting scheduled task");
    }
    if (data) {
      const updatedTasks = scheduledTasks.filter((task) => task.id !== taskId);
      setScheduledTasks(updatedTasks);
    }
  };

  const showPreview = (task) => {
    setPreviewMessage(task);
    setPreviewVisible(true);
  };

  const clearPreview = () => {
    setPreviewMessage({});
    setPreviewVisible(false);
  };

  // This function is called when table got updated
  const handleTableChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setTableState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
    setShowFilter(false);
  };

  const scheduledTasksColumns = [
    {
      title: "Created at",
      dataIndex: "createdTime",
      width: "10%",
      sorter: (a, b) =>
        moment(a.scheduledTime).unix() - moment(b.scheduledTime).unix(),
    },
    {
      title: "Sent as",
      dataIndex: "createdByName",
      width: "10%",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "10%",
      key: "type",
      filteredValue: tableState.filteredInfo.type,
      filterIcon: <FilterFilled onClick={() => setShowFilter(!showFilter)} />,
      filterDropdownVisible: showFilter,
      filters: [
        { text: "Survey Questions", value: "sendSurveyQuestions" },
        { text: "Direct Message", value: "sendDMs" },
        { text: "Channel Post", value: "postToChannel" },
        { text: "Onboarding Questions", value: "sendDMsOnboarding" },
      ],
      onFilter: (value, record) => {
        return record.run_function === value;
      },
    },
    {
      title: "Info",
      dataIndex: "info",
      width: "20%",
      render: (text, record) => (
        <Space>
          <div>{record.info}</div>

          <Tooltip title="Preview message">
            <InfoCircleOutlined
              style={{ fontSize: 18 }}
              onClick={() => showPreview(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: "Scheduled time",
      dataIndex: "scheduledTime",
      width: "15%",
      sorter: (a, b) =>
        moment(a.scheduledTime).unix() - moment(b.scheduledTime).unix(),
    },
    {
      title: "Timezone",
      dataIndex: "scheduledTimezone",
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "10%",
    },
    {
      title: "Actions",
      render: (text, record) => (
        <Space size="middle">
          {record.status !== "completed" ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                }}
              >
                <Tooltip title="Delete scheduled task">
                  <Popconfirm
                    placement="top"
                    title="Are you sure you want to delete?"
                    onConfirm={() => deleteScheduledTask(record.id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <DeleteOutlined
                      style={{ fontSize: 24, color: "#6C6C6C" }}
                    />
                  </Popconfirm>
                </Tooltip>
              </div>
            </div>
          ) : (
            ""
          )}
        </Space>
      ),
      width: "10%",
    },
  ];

  const filterSendDMsOnboarding = () => {
    setShowFilter(!showFilter);
  };

  return (
    <div>
      <Row justify="spaced-around" gutter={[32, 32]}>
        <Col lg={24} md={24}>
          <Card
            title="Scheduled messages"
            bordered={false}
            headStyle={{
              textAlign: "left",
            }}
            extra={
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button onClick={filterSendDMsOnboarding} size="medium" block>
                  <FilterFilled />
                  Filter
                </Button>

                <Button
                  danger
                  size="small"
                  onClick={loadPageData}
                  style={{ marginLeft: 10, alignItems: "center" }}
                >
                  <SyncOutlined />
                </Button>
              </div>
            }
          >
            <div style={{ width: "100%", height: "100%" }}>
              <Spin spinning={loading}>
                <Table
                  dataSource={scheduledTasks}
                  columns={scheduledTasksColumns}
                  onChange={handleTableChange}
                />
              </Spin>
            </div>
          </Card>
        </Col>
      </Row>
      <Modal visible={isPreviewVisible} onCancel={clearPreview} footer={null}>
        <PreviewMessageModal task={previewMessage} tagdata={allTags} />
      </Modal>
    </div>
  );
};

export default ScheduledMessagesTable;
